import Request from '@/utils/request'

// 发送验证码
export const apiSentCode = (data) => {
  return Request({
    url: '/web/user/mail/captcha',
    method: 'post',
    data,
  })
}

// 确认提现
export const apiConfirmWithdraw = (data) => {
  return Request({
    url: '/web/advisor/withdrawal',
    method: 'post',
    data,
  })
}

// 获得自己的金币和邮箱信息
export const apiFetchUserInfo = (params) => {
  return Request({
    url: '/web/user/info',
    method: 'get',
    params,
  })
}

// 获得自己提现信息
export const apiWithdrawHistory = (params) => {
  return Request({
    url: '/web/advisor/coins/change/list',
    method: 'get',
    params,
  })
}

// 提现之前 验证check 最近7天违规
export const apiWithdrawCheck = (walletType, data) => {
  return Request({
    url: `/api/v2/app/withdraw/wallet/${walletType}/pre/check`,
    method: 'post',
    data,
  })
}

// 获取check 数据
export const apiWithdrawCheckData = (walletType, params) => {
  return Request({
    url: `/api/v2/app/withdraw/wallet/${walletType}/pre/check/cfg`,
    method: 'get',
    params,
  })
}

// 新年提示 在规定时间内显示
export const apiNewyearDiaShowTime = (data) => {
  return Request({
    url: '/api/v2/app/withdraw/wallet/holiday/notification',
    method: 'post',
    data,
  })
}
